
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { label } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["size", "children"];
var Label = function Label(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx("label", _extends({
    css: function css(theme) {
      return label(theme, {
        size: size
      });
    }
  }, rest), children);
};

export { Label as default };
//# sourceMappingURL=Label.js.map
